module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Bold.c170b1ea.woff";